import { AnyAction } from 'redux';

import { FormatError } from '@/services/api';

export type ErrorState<T = any> = {
  // key: *store.asyncActions.*.typePrefix
  [key: string]: FormatError<T>;
};

const initialState: ErrorState = {};

export const RESET_ERROR_STATE = 'RESET_ERROR_STATE';
export const resetErrorState = () => ({
  type: RESET_ERROR_STATE,
});

export default (state = initialState, action: AnyAction) => {
  const { type, payload } = action;
  const matches = /(.*)\/(fulfilled|rejected)/.exec(type);

  if (type === RESET_ERROR_STATE) {
    return initialState;
  }

  if (!matches) {
    return state;
  }

  // requestName: *store.asyncActions.*.typePrefix
  // requestState: fulfilled | rejected
  const [, requestName, requestState] = matches;

  if (requestState === 'rejected') {
    return {
      ...state,
      [requestName]: payload.error,
    };
  } else {
    return {
      ...state,
      [requestName]: null,
    };
  }
};
